import { StatusCodes } from "http-status-codes";
import { request } from "../api";
import { headers } from "../../../config/config";
import { MESSAGE } from "../../../constants/api/message";
import { AUTHORIZATION } from "../../../constants/api/auth";

const { post, get, patch, put } = request;
const { Authorization, Bearer } = AUTHORIZATION;

export type activePlanForEmployeeReportPayloadType = {
	group_number: number;
	plan_name:
		| "Health Plan"
		| "Clinic Card"
		| "KSOP"
		| "Group Short Term Disability"
		| "Helping Our Own"
		| "Christmas Club Election"
		| "Group Long Term Disability(Class 1)"
		| "Group Long Term Disability(Class 2)"
		| "Group Life Insurance"
		| "all";
};

const initialRoute = "reports";

export const activePlanForEmployeeReport = async (
	activePlanForEmployeeReportPayload: activePlanForEmployeeReportPayloadType
) => {
	try {
		const payload = JSON.stringify(activePlanForEmployeeReportPayload);
		const endpoint = `${initialRoute}/enrollments/get-active-health-plan-for-employee`;
		const token = localStorage.getItem("@jwt");
		const response = await post(endpoint, payload, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (error: any) {
		if (error.response.status === StatusCodes.BAD_REQUEST) {
			const { message } = error.response.data;

			alert(message);
		} else if (error.response.status === StatusCodes.UNAUTHORIZED) {
			const { message } = error.response.data;

			alert(message);
		} else {
			throw error;
		}
	}
};
